import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import {
  AnyPropertyChanged,
  useEntityPropertyChangedCallback
} from '../../../hooks/entity/useEntityPropertyChangedCallback';

export type EditTimeTrackingActivityFormProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  timeTrackingActivity: TimeTrackingActivity;
  onPropertyChanged: AnyPropertyChanged<TimeTrackingActivity>;
};

export const EditTimeTrackingActivityForm: FunctionComponent<EditTimeTrackingActivityFormProps> =
  React.memo((props) => {
    const { timeTrackingActivity, onPropertyChanged, ...remainingProps } =
      prepareProps({ props, ignoreChildren: true });

    const { t } = useTranslation();

    const handleNameChanged = useEntityPropertyChangedCallback(
      timeTrackingActivity,
      'name',
      onPropertyChanged
    );

    return (
      <div {...remainingProps}>
        <BufferedTextInput
          label={t('entities.TimeTrackingActivity.name')}
          value={timeTrackingActivity.name}
          onInput={handleNameChanged}
          data-testid="EditTimeTrackingActivityForm.NameInput"
        ></BufferedTextInput>
      </div>
    );
  });
